/*
 * @fileOverView StickyNav component definition
 */

import Vue from 'vue';
import Throttle from 'utils/Throttle';
import {Events, Intervals, Distances} from 'utils/Constants';

/**
 * [StickyNav Vue]
 * @type {class}
 */
Vue.component('stickynav-vue', {
  data: function() {
    return {
      currentPosition: 0
    }
  },

  computed: {
    /**
     * [determine the progress down the page]
     * @return {integer} [a value from 0-100]
     */
    progress: function() {
      return ((this.$window.outerHeight() + this.currentPosition) / $(document).height()) * 100;
    },
    /**
     * [determines whether to show the sticky]
     * @return {bool} [returns true if current scrollTop > defaultScrollDistance]
     */
    showSticky: function() {
      return this.currentPosition > Distances.SCROLL_VISIBILITY_TRIGGER;
    }
  },

  watch: {
    showSticky: function(value) {
      // Allows for other sticky elements to be positioned accordingly.
      if (value) {
        document.body.classList.add('js-stickyNav-active');
      }
      else {
        document.body.classList.remove('js-stickyNav-active');
      }
    }
  },

  methods: {
    /**
    * Handles the scroll event
    *
    * @method handleScroll
    * @public
    */
    handleScroll(e) {
      this.currentPosition = this.$window.scrollTop();
    }
  },

  created() {
    this.$window = $(window).first();
  },

  mounted() {
    const callback = Throttle(e => this.handleScroll(e), Intervals.SCROLL_INTERVAL);
    this.$window.on(Events.SCROLL, callback);
    this.handleScroll();
        document.addEventListener('DOMContentLoaded', function() {
      const stickyNavContainer = document.querySelector('.stickyNav-container');
      const saveArticleContainer = stickyNavContainer.querySelector('.bookmark-article-btn') !== null;
      const navTitle = document.querySelector('.stickyNav-title');
      if (saveArticleContainer) {
        navTitle.classList.add('dynamicTitle');
      }
    });

    document.addEventListener('DOMContentLoaded', function() {
      function applyStylingToParentDiv(parentDiv) {
        var screenWidth = window.innerWidth;
        if (parentDiv) {
          var innerSpan = parentDiv.querySelector('span');
          if (innerSpan) {
            const isLargeScreen = screenWidth > 1500;
            const isMediumScreen = screenWidth > 920 && innerSpan.offsetWidth < 500;
            const isWideInnerSpan = innerSpan.offsetWidth > 820;
            if (isLargeScreen) {
              if (isWideInnerSpan) {
                parentDiv.classList.remove('dynamic-sticky-title-sm');
                parentDiv.classList.add('dynamic-sticky-title');
              } else {
                parentDiv.classList.remove('dynamic-sticky-title');
                parentDiv.classList.add('dynamic-sticky-title-sm');
              }
            } else {
              if (isMediumScreen) {
                parentDiv.classList.add('dynamic-sticky-title-sm');
                parentDiv.classList.remove('dynamic-sticky-title');
              } else {
                parentDiv.classList.remove('dynamic-sticky-title', 'dynamic-sticky-title-sm');
              }
            }
            var textContent = innerSpan.textContent;
            var characterCount = textContent.replace(/\s/g, '').length;
            if (characterCount < 20) {
              parentDiv.style.right = '0';
              parentDiv.style.left = '0';
              parentDiv.style.zIndex = '-1';
            } else {
              parentDiv.style.removeProperty('right');
              parentDiv.style.removeProperty('left');
              parentDiv.style.removeProperty('zIndex');
            }
          }
        }
      }
      function handleResize() {
        applyStylingToParentDiv(document.querySelector('.dynamicTitle'));
        applyStylingToParentDiv(document.querySelector('.stickyNav-title'));
      }
      // Initial styling
      handleResize();
      // Apply styling on window resize
      window.addEventListener('resize', handleResize);
    });

  }
});
